export const GET_SHIFT = 'GET_SHIFT';
export const GET_SHIFT_START = `${GET_SHIFT}_START`;
export const GET_SHIFT_SUCCESS = `${GET_SHIFT}_SUCCESS`;
export const GET_SHIFTS = 'GET_SHIFTS';
export const GET_SHIFTS_START = `${GET_SHIFTS}_START`;
export const GET_SHIFTS_SUCCESS = `${GET_SHIFTS}_SUCCESS`;
export const GET_SHIFTS_FAIL = `${GET_SHIFTS}_FAIL`;
export const POST_SHIFT = 'POST_SHIFT';
export const POST_SHIFT_START = `${POST_SHIFT}_START`;
export const POST_SHIFT_SUCCESS = `${POST_SHIFT}_SUCCESS`;
export const POST_SHIFT_FAIL = `${POST_SHIFT}_FAIL`;
export const SHIFT_ADD_MEMBER = 'SHIFT_ADD_MEMBER';
export const SHIFT_ADD_MEMBER_START = `${SHIFT_ADD_MEMBER}_START`;
export const SHIFT_ADD_MEMBER_SUCCESS = `${SHIFT_ADD_MEMBER}_SUCCESS`;
export const SHIFT_ADD_MEMBER_FAIL = `${SHIFT_ADD_MEMBER}_FAIL`;

export const addMember = ({ groupName, shiftName, member }) => {
  let uri;
  let params;

  if (shiftName) {
    uri = `/webapi/xm/1/groups/${encodeURIComponent(
      groupName,
    )}/shifts/${encodeURIComponent(shiftName)}/members`;

    params = { recipient: { id: member } };
  } else {
    uri = `/webapi/xm/1/groups/${encodeURIComponent(groupName)}/members`;

    params = {
      id: member,
      recipientType: 'PERSON',
    };
  }

  return {
    type: SHIFT_ADD_MEMBER,
    meta: {
      xmApi: true,
      uri,
      method: 'post',
      isUriEncoded: true,
      params,
    },
  };
};

export const getShifts = groupName => ({
  type: GET_SHIFTS,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/groups/${encodeURIComponent(groupName)}/shifts`,
    params: {
      include: 'memberCount',
    },
    method: 'get',
    isUriEncoded: true,
  },
});

export const getShift = ({ groupId, shiftId }) => ({
  type: GET_SHIFT,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/groups/${encodeURIComponent(
      groupId,
    )}/shifts/${encodeURIComponent(shiftId)}`,
    method: 'get',
    isUriEncoded: true,
    customUriWithParamsGenerator: x => x,
  },
});

export const postShift = ({ params, groupId }) => ({
  type: POST_SHIFT,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/groups/${encodeURIComponent(groupId)}/shifts`,
    method: 'post',
    isUriEncoded: true,
    params,
  },
});
